import cn from 'classnames';
import React from 'react';
import typeExpression from './utils/tsDocTypeExpression';

var styles = require('./TsDocTypeExpression-styles.module.css');

export default function TsDocTypeExpression(_ref) {
  var type = _ref.type,
      className = _ref.className,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact;
  return /*#__PURE__*/React.createElement("span", {
    className: cn(className, styles.TsDocTypeExpression)
  }, typeExpression(type, {
    compact: compact
  }));
}